// extracted by mini-css-extract-plugin
export default {"tab_container":"MultiTab_tab_container__AEHMc","tab_text":"MultiTab_tab_text__3T-ZY"};